/* RESPONSIBLE TEAM: team-messenger */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';
export default class CarouselSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    localizedCarouselContents: { embedded: 'always' },
    textColor: {
      serialize: false,
    },
    backgroundColor: {
      serialize: false,
    },
    actionsColor: {
      serialize: false,
    },
    verticalAlignment: {
      serialize: false,
    },
  };
}
